// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1AppUserSchema } from './v1/appUserSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const getAppPathParamsSchema = z.object({
  id: z.number().int().describe("App id"),
});

export const getAppHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description App connections
 */
export const getApp200Schema = z.array(z.lazy(() => v1AppUserSchema));

/**
 * @description App not found
 */
export const getApp404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const getAppQueryResponseSchema = z.lazy(() => getApp200Schema);
